


















































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { STATUSES as SERVICE_REQUEST_STATUSES } from '@/constants/service_request';
import ServiceOrderCreate from '@/pages/Business/ServiceOrder/ServiceOrderCreate.vue';
import ServiceOrderRead from '@/pages/Business/ServiceOrder/ServiceOrderRead.vue';
import ServiceRequestReadServiceOrderPaymentMethods from './Read/ServiceRequestReadServiceOrderPaymentMethods.vue';
import ServiceRequestReadServiceCandidate from './Read/ServiceRequestReadServiceCandidate.vue';
import _ from 'lodash';

@Component({
  components: {
    ServiceOrderCreate,
    ServiceOrderRead,
    ServiceRequestReadServiceOrderPaymentMethods,
    ServiceRequestReadServiceCandidate,
  },
  computed: {
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
    ...mapState('ServiceRequest', {
      activeServiceRequest: 'activeServiceRequest',
    }),
  },
})
export default class ServiceRequestRead extends Vue {
  @Prop({ default: false }) readonly needMarginTop!: boolean;
  @Prop() readonly serviceRequestOid!: string;

  isMounted = false;
  isLoading = false;

  business!: Model;
  activeServiceRequest!: Model;
  serviceRequestStatues = SERVICE_REQUEST_STATUSES;

  showServiceOrderCreate = false;
  showServiceOrderRead = false;

  isEnoughServiceItem = false;
  isConsumingServiceItem = false;

  serviceItems!: Model[];
  serviceItemTotalAvailableQuantity!: [];

  isApiFetch = {
    isApiFetchServiceItemsFinished: false,
    isApiFetchServiceItemTotalAvailableQuantityFinished: false,
    isApiFetchServiceRequestFinished: false,
  };

  beforeMount() {
    this.init();
  }

  async init() {
    this.isLoading = true;

    this.isApiFetch = {
      isApiFetchServiceItemsFinished: false,
      isApiFetchServiceItemTotalAvailableQuantityFinished: false,
      isApiFetchServiceRequestFinished: false,
    };

    let oid;
    if (this.activeServiceRequest) {
      oid = this.activeServiceRequest.object_id;
    }
    if (this.$route.params.serviceRequestOid) {
      oid = this.$route.params.serviceRequestOid;
    }
    await this.$store.dispatch('ServiceRequest/fetch', oid).then(() => {
      this.isApiFetch['isApiFetchServiceRequestFinished'] = true;
    });

    this.$store.dispatch('ServiceItem/fetchList').then((response) => {
      this.serviceItems = response.data.data;
      this.isApiFetch['isApiFetchServiceItemsFinished'] = true;
    });

    this.$store
      .dispatch(
        'ServiceItem/serviceItemTotalAvailableQuantity',
        this.business.object_id
      )
      .then((response) => {
        this.serviceItemTotalAvailableQuantity = response.data.data;
        this.isApiFetch[
          'isApiFetchServiceItemTotalAvailableQuantityFinished'
        ] = true;
      });
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }

      if (!isFinished) {
        return;
      }

      // When all APIs call finished,
      // calculate how many questack against to the SI is requested in total.
      for (const candidate of this.activeServiceRequest.service_candidates) {
        const oid = candidate.service_item.object_id;
        const serviceItem = this.serviceItems.find(
          (item) => item.object_id === oid
        );
        if (serviceItem) {
          serviceItem.current_quantity = _.get(
            this.serviceItemTotalAvailableQuantity,
            oid,
            0
          );
          if (serviceItem.requested_quantity) {
            serviceItem.requested_quantity += 1;
          } else {
            serviceItem.requested_quantity = 1;
          }
        }
      }

      // calculate current business available questack quantity
      // and whether questack is enough for the request
      let isEnoughServiceItem = true;

      for (const [key, item] of this.serviceItems.entries()) {
        if (item.object_id) {
          item.current_quantity = _.get(
            this.serviceItemTotalAvailableQuantity,
            item.object_id,
            0
          );

          // calculate the actual required quantity for service order create component
          if (item.current_quantity < item.requested_quantity) {
            item.required_quantity =
              item.requested_quantity - item.current_quantity;
            isEnoughServiceItem = false;
          } else {
            item.required_quantity = 0;
          }
        }
      }

      this.isEnoughServiceItem = isEnoughServiceItem;

      this.isMounted = true;
      this.isLoading = false;
    }
  }

  async consume() {
    this.isConsumingServiceItem = true;
    await this.$store.dispatch('ServiceRequest/consume');
    this.showServiceOrderRead = false;
    this.showServiceOrderCreate = false;
    this.init();
    this.$emit('paid');
  }
}
